import { reserize, serialize } from '@/plugins/utils'
import { thirdAuth } from '@/apis/user'
import { useGlobal } from '@/util/useLoading'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'

interface M {
  customerShopPlatform: number
  customerShopId: string
  customerShopPlatName: string
  customerShopLogo: string
  customerShopName: string
  customerShopUrl: string
  customerShopKey: string
  clientId: string
  clientSecret: string
  accessToken: string
}

export const authShopify = (model: M): any => {
  const { customerShopUrl: url, clientId, clientSecret, customerShopId } = model
  return thirdAuth({
    clientId,
    clientSecret,
    url,
    customerShopId,
    thirdShopType: 2
  }).then((res) => {
    return res.success
  })
  // const { customerShopUrl, customerShopId, clientId, clientSecret } = model
  // if (customerShopUrl) {
  //   const shop = customerShopUrl.replace(/(^http(s)?:\/\/)|(\/?$)/g, '')
  //   const params = {
  //     response_type: 'code',
  //     redirect_uri: 'https://client-test.theckbs.com' || location.origin,
  //     state: encodeURIComponent(`shop_src=shopify&shop_id=${customerShopId}`)
  //   }
  //   window.open(
  //     `https://${shop}/admin/oauth/authorize?client_id=a81b1d6b30fd07fc4fa9c6b38ad935e1&scope=read_products%2Cwrite_products%2Cread_customers%2Cread_orders%2Cwrite_orders%2Cread_shopify_payments_payouts%2Cread_shopify_payments_disputes%2Cread_inventory%2Cwrite_inventory&` +
  //       serialize(params),
  //     '_blank',
  //     'width=1000,height=800,top=120,left=100,menubar=no,toolbar=no,status=no,scrollbars=yes'
  //   )
  // } else {
  //   ElMessage.error('请填写店铺地址后再授权')
  // }
}

export const authCafe24 = (model: M): void => {
  const { customerShopId, customerShopUrl } = model
  const params = {
    response_type: 'code',
    redirect_uri: location.origin + '/',
    state: encodeURIComponent(`shop_src=cafe24_${customerShopId}`)
  }
  window.open(
    `https://${customerShopUrl.replace(/^http(s)?(:\/\/)?/g, '').replace(/\/$/, '')}/api/v2/oauth/authorize?client_id=tiKhsXxIC1LqEyeKGRmeiN&scope=mall.read_application,mall.write_application,mall.read_category,mall.write_category,mall.read_product,mall.write_product,mall.read_collection,mall.write_collection,mall.read_supply,mall.write_supply,mall.read_order,mall.write_order,mall.read_customer,mall.read_store,mall.read_salesreport,mall.read_shipping,mall.write_shipping,mall.read_translation,mall.write_translation,mall.read_analytics&` +
    serialize(params),
    '_blank',
    'width=1000,height=800,top=120,left=100,menubar=no,toolbar=no,status=no,scrollbars=yes'
  )
}

export const authBase = (model: M): void => {
  const { customerShopId } = model
  const params = {
    response_type: 'code',
    redirect_uri: location.origin,
    state: encodeURIComponent(`shop_src=base&shop_id=${customerShopId}`)
  }
  window.open(
    'https://api.thebase.in/1/oauth/authorize?client_id=3c3f6b035a49ee335a130a13df599554&scope=read_users%20read_users_mail%20read_items%20read_orders%20read_savings%20write_items%20write_orders&' +
    serialize(params),
    '_blank',
    'width=1000,height=800,top=120,left=100,menubar=no,toolbar=no,status=no,scrollbars=yes'
  )
}

export const authAmazon = (model: M): void => {
  const { customerShopId } = model
  const params = {
    application_id: 'amzn1.sp.solution.7a9b4839-2094-4d78-b40d-9a17cc427555',
    redirect_uri: location.origin + '/b2b',
    state: encodeURIComponent(`shop_src=amazon&shop_id=${customerShopId}`),
    version: 'beta'
  }
  window.open(
    'https://sellercentral.amazon.co.jp/apps/authorize/consent?' +
    serialize(params),
    '_blank',
    'width=1000,height=800,top=120,left=100,menubar=no,toolbar=no,status=no,scrollbars=yes'
  )
}
export const authStores = (model: M): void => {
  const { customerShopId } = model
  const params = {
    client_id: '637d8162-0d90-4981-9d24-a180b6d43e79',
    redirect_uri: location.origin + '/',
    response_type: 'code',
    scope: 'retail.shop.read%20retail.shop.write%20offline_access',
    state: encodeURIComponent(`shop_src=stores&shop_id=${customerShopId}`),
    prompt: 'login'
  }
  window.open(
    'https://api.id.stores.jp/oauth2/auth?' +
    serialize(params),
    '_blank',
    'width=1000,height=800,top=120,left=100,menubar=no,toolbar=no,status=no,scrollbars=yes'
  )
}

export const callback = ({ query }: any): void => {
  console.log(query, location.href.includes('/auth'), query?.state)
  const api = useGlobal((src: any, params) => {
    // 参数拼接在一起的情况
    if (src.includes('_')) {
      const [type, shopId] = src.split('_')
      src = type
      params.shop_id = shopId
    }
    const shops: any = {
      base: (params: any) => {
        const { code, shop_id: customerShopId } = params
        return thirdAuth({
          code,
          customerShopId,
          thirdShopType: 1
        })
      },
      cafe24: (params: any) => {
        const { code, shop_id: customerShopId } = params
        return thirdAuth({
          code,
          customerShopId,
          thirdShopType: 6
        })
      },
      shopify: (params: any) => {
        const {
          code,
          shop: shopUrl,
          shop_id: customerShopId
        } = params
        return thirdAuth({
          customerShopId,
          code,
          url: 'https://' + shopUrl,
          thirdShopType: 2
        })
      },
      amazon: (params: any) => {
        const {
          spapi_oauth_code: code,
          selling_partner_id: sellingPartnerId,
          shop_id: customerShopId
        } = params
        return thirdAuth({
          code,
          customerShopId,
          sellingPartnerId,
          thirdShopType: 4
        })
      },
      stores: (params: any) => {
        const { code, shop_id: customerShopId } = params
        return thirdAuth({
          code,
          customerShopId,
          thirdShopType: 3
        })
      }
    }
    return shops[src](params)
  })
  // 避免授权页影响
  if (!location.href.includes('/auth') && query?.state) {
    const state = reserize(decodeURIComponent(query.state.toString()))

    api(state.shop_src, {
      ...query,
      ...state
    }).then((res: any) => {
      localStorage.__reload__ = res.success.toString()
      console.log(res)
      if (res.success) {
        setTimeout(() => {
          window.close()
        }, 2000)
      } else {
      }
    })
  }
}
